var React = require('react');

function Electric (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"33.0078","cy":"33","r":"33","fill":"#F5F4F4","key":0}),React.createElement("path",{"d":"M26.0078 37.5494L30.2269 17H43.8456L34.8733 32.5495H40.3208L26.0078 57L31.6155 37.5494H26.0078Z","fill":"#FF9900","key":1})]);
}

Electric.defaultProps = {"width":"66","height":"66","viewBox":"0 0 66 66","fill":"none"};

module.exports = Electric;

Electric.default = Electric;
